// extracted by mini-css-extract-plugin
export var personalStyle = "hr-module--personal-style--5WXoO";